import PropTypes from 'prop-types';
import React from 'react';

import SyndeticsUnboundEnrichment from 'app/components/bibs/shared/SyndeticsUnboundEnrichment';

import './MoreFromSyndeticsUnbound.scss';

const MoreFromSyndeticsUnbound = ({ enrichmentIds }) => {
  return (
    <div className="cp-more-from-syndetics-unbound">
      {enrichmentIds.map(enrichmentId => {
        return (
          <section className="enrichment" key={`unbound_${enrichmentId}`}>
            <SyndeticsUnboundEnrichment enrichmentId={enrichmentId} />
          </section>
        );
      })}
    </div>
  );
};

MoreFromSyndeticsUnbound.propTypes = {
  enrichmentIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default MoreFromSyndeticsUnbound;
